let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jkZvt")).then(() => parcelRequire('a5z0r'));